import { GrapevineChatApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineChatApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new GrapevineChatApi(configuration), [configuration]);
};
